
export const PALETTE_CONSTANT = [
  {
    type: 'TEXT',
    priority: 'FIRST',
    editors: ['PAGE', 'GATING', 'LIVE_ELEMENT', 'PALETTE_COMPONENT', 'MY_DESIGN'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'BUTTON',
    priority: 'FIRST',
    editors: ['PAGE', 'GATING', 'LIVE_ELEMENT', 'PALETTE_COMPONENT', 'MY_DESIGN'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'MEDIA',
    priority: 'FIRST',
    editors: ['PAGE', 'GATING', 'LIVE_ELEMENT', 'PALETTE_COMPONENT', 'MY_DESIGN'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'ICONS',
    priority: 'FIRST',
    editors: ['PAGE', 'GATING', 'LIVE_ELEMENT', 'PALETTE_COMPONENT', 'MY_DESIGN'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'SECTIONS',
    priority: 'SECOND',
    editors: ['PAGE', 'MY_DESIGN', 'PALETTE_COMPONENT', 'LIVE_ELEMENT'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'CAROUSELS',
    priority: 'SECOND',
    editors: ['PAGE', 'MY_DESIGN', 'PALETTE_COMPONENT'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'ASSET_GRID',
    priority: 'SECOND',
    editors: ['PAGE', 'PALETTE_COMPONENT'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'FORMS',
    priority: 'SECOND',
    editors: ['PAGE', 'GATING', 'LIVE_ELEMENT', 'PALETTE_COMPONENT', 'MY_DESIGN'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    type: 'MENUS',
    priority: 'SECOND',
    editors: ['PAGE', 'MY_DESIGN', 'PALETTE_COMPONENT', "LIVE_ELEMENT", "SECTION"],
    storyboardTypes: ['LANDING_PAGE', 'RESOURCE_CENTER']
  },
  {
    type: 'SEEK',
    priority: 'SECOND',
    editors: ['PAGE', 'PALETTE_COMPONENT'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER']
  },
  { 
    type: 'EMBED',
    priority: 'SECOND',
    editors: ['PAGE', 'GATING', 'LIVE_ELEMENT', 'PALETTE_COMPONENT', 'MY_DESIGN'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    id: 'ANCHOR',
    name: 'Anchor',
    type: 'ANCHOR',
    priority: 'THIRD',
    editors: ['PAGE'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  },
  {
    id: 'LIVE_ELEMENT',
    name: 'Live Element',
    type: 'LIVE_ELEMENT',
    priority: 'THIRD',
    editors: ['PAGE', 'GATING', 'MY_DESIGN', 'PALETTE_COMPONENT'],
    storyboardTypes: ['INTERACTIVE_CONTENT', 'LANDING_PAGE', 'RESOURCE_CENTER', 'SPATIAL']
  }
]